module.exports = __webpack_public_path__ + "static/khairul-5be3c18c9e07fdf7a85dd063d72c134d.webm";